export default {
  inject: {
    processShell: {
      from: "processShell",
      default: null,
    },
  },
  props: {
    operationName: String,
    authority: String,
  },
  computed: {},
  methods: {
    isOperationDisabled() {
      if (this.operationName && this.processShell) {
        if (this.processShell.getDisabled(this.operationName)) {
          return true;
        }
      }
      return false;
    },
  },
};
